var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-alert",
        {
          attrs: { type: "info", dismissible: "" },
          model: {
            value: _vm.alert,
            callback: function ($$v) {
              _vm.alert = $$v
            },
            expression: "alert",
          },
        },
        [
          _vm._v(
            "\n    Report generation request is submitted. Please check the status of the process at the "
          ),
          _c("a", { on: { click: _vm.goToMessageCenter } }, [
            _vm._v("message center"),
          ]),
          _vm._v(".\n  "),
        ]
      ),
      _vm._v(" "),
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: { title: "Report generation" },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function ({ isError, fileResults }) {
              return [
                isError && fileResults && fileResults.length > 0
                  ? _c(
                      "SecondaryBtn",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.downloadResults(fileResults)
                          },
                        },
                      },
                      [_vm._v("\n        Download anyway\n      ")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: {
            disabled: _vm.isSubmittingReportRequest,
            color: "info",
            loading: _vm.isSubmittingReportRequest,
          },
          on: {
            click: function ($event) {
              return _vm.generateReportAsync()
            },
          },
        },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("save_alt")]),
          _vm._v(" "),
          _c("div", { staticClass: "text-capitalize" }, [
            _vm._v(" Asynchronous Report Download"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }